import * as React from 'react';
import { connect } from 'react-redux';
import Datepicker from '../../../common/datepicker/datepicker';
import { formatDate, getTimestamp, newDate } from '../../calendar.model';
import CalendarGridMarkup from '../../calendar-grid/calendar-grid-markup';
import { getEventsForPassengerMove, movePassenger } from '../weight-and-balance.actions';
import { CONFIRM_PASSENGER_MOVE, DEFAULT_MOVE_PASSENGER_DATA } from './passenger.consts';
import { scrollModalTop } from '../../../common/modal/utils';
import { setModal } from '../../../ui/ui.actions';
import Modal from '../../../common/modal';
import { EventTime } from '../../event/event-time';
import Indication from '../../../ui/indication';
import { selectUIMessages } from '../../calendar.selectors';
import { WEIGHT_AND_BALANCE } from '../weight-and-balance.consts';

class PassengerMove extends React.Component {
  constructor(props: Props) {
    super(props);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleConfirmMove = this.handleConfirmMove.bind(this);
    this.handleCancelConfirmMove = this.handleCancelConfirmMove.bind(this);
    this.handleMove = this.handleMove.bind(this);

    this.state = {
      moveDate: newDate(getTimestamp(new Date(props.URL.element))),
      data: DEFAULT_MOVE_PASSENGER_DATA
    };
  }

  async componentDidMount() {
    await this.getEvents(formatDate(this.state.moveDate.getTime() / 1000, 0, 'Y-m-d', false, false));
    scrollModalTop();
  }

  async getEvents(date) {
    const { getEventsForPassengerMove, row, seat } = this.props;
    const data = await getEventsForPassengerMove({ date, row, seat });

    this.setState({ data });
  }

  handleDateChange(value) {
    const moveDate = formatDate(value.getTime() / 1000, 0, 'Y-m-d', false, false);
    this.setState({
      moveDate: value
    });
    this.getEvents(moveDate);
  }

  handleConfirmMove(e) {
    const { setModal } = this.props;
    const { event } = e.currentTarget.dataset;

    setModal(true, CONFIRM_PASSENGER_MOVE);
    this.setState({ newEvent: event });
  }

  handleCancelConfirmMove() {
    const { setModal } = this.props;

    setModal(false, CONFIRM_PASSENGER_MOVE);
  }

  async handleMove() {
    const { row, seat, movePassenger, onMove } = this.props;
    const { newEvent } = this.state;
    const response = await movePassenger({ row, seat, newEvent });

    if (response.ok) {
      onMove();
    }
  }

  render() {
    const { user, UI, passengerName, UIMessages } = this.props;
    const { moveDate, data, newEvent } = this.state;

    const event = newEvent && data.events[newEvent];
    const resource = event && data.resources[event.resourceID];
    const timezone = event && { offset: event.timeZoneOffset };

    return (
      <div>
        <p className="text-bold">
          Move passenger to another event by selecting the new event below:
        </p>
        <Datepicker
          className="form-control inner-datepicker move-passenger-datepicker"
          disabled={UI.progress}
          selected={moveDate}
          dateFormat={user.settings.date}
          onChange={this.handleDateChange}
          required
        />
        {data.events && Object.keys(data.events).length ? (
          <CalendarGridMarkup
            passengersInfoFirst
            detailed={false}
            data={data}
            onEventClick={this.handleConfirmMove}
          />
        ) : (
          <p className="text-center text-primary">There are no events for selected date</p>
        )}
        <Modal
          cancelBackdropClick={true}
          isOpen={Boolean(UI.modals.CONFIRM_PASSENGER_MOVE)}
          onClose={this.handleCancelConfirmMove}
          width="400px"
          header={
            <span>
              <img
                className="margin-l-r-5"
                src={`${serverData._uri}/public/images/icons/weight.svg`}
                alt="weight icon"
              />
              Confirm passenger move
            </span>
          }
          className="confirm-modal"
          footer={
            <button
              className="btn btn-sm btn-success pull-right"
              disabled={UI.progress}
              onClick={this.handleMove}
            >
              Confirm
            </button>
          }
        >
          {event ? (
            <div className="passenger-move">
              <div className="passenger-move-event-info">
                <div className="passenger-move-info-block">
                  <div>Passenger</div>
                  <div>Organization</div>
                  <div>Location</div>
                  <div>Aircraft</div>
                  <div>Pilot</div>
                </div>
                <div>
                  <div>{passengerName}</div>
                  <div>{event.organizationName}</div>
                  <div>{resource?.locationName ?? ''}</div>
                  <div>{resource?.resourceName ?? 'Unavailable Resource'}</div>
                  <div>
                    {event.pilotName} {event.pilotSurname}
                  </div>
                </div>
              </div>
              <hr />
              <div className="passenger-move-event-time-block">
                <div className="passenger-move-event-time">
                  <EventTime
                    title="Start time"
                    user={user}
                    timezone={timezone}
                    date={event.startTime}
                  />
                </div>
                <div className="passenger-move-event-time">
                  <EventTime
                    title="End time"
                    user={user}
                    timezone={timezone}
                    date={event.finishTime}
                  />
                </div>
              </div>
            </div>
          ) : null}

          <div className="top-indent">
            <Indication className="event-form-indication" messages={UIMessages} />
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  UIMessages: selectUIMessages(WEIGHT_AND_BALANCE)(state),
  UI: state.UI,
  URL: state.URL,
  user: state.user
});

export default connect(
  mapStateToProps,
  {
    getEventsForPassengerMove,
    movePassenger,
    setModal
  }
)(PassengerMove);
